// La moneda del anuncio: una sola para el anuncio, sus alojamientos y sus tarifas.
export const monedaAnuncio = {
  chipTitle: "عملة الإعلان",
  change: "تغيير",
  mismatchDot: "عملات هذا الإعلان غير متطابقة",
  channexText: "هذا الإعلان مرتبط بـ Channex. لا يمكن هناك تغيير عملة السعر: يجب إعادة إنشائه. راسلنا وسنقوم بذلك دون إيقاف مبيعاتك على منصات الحجز.",
  channexOnly: "مرتبط بـ Channex: يمكنه استخدام {currency} فقط، وهي عملة أسعاره هناك.",
  modal: {
    title: "عملة الإعلان",
    lead: "هي العملة التي تحصّل بها من ضيوف هذا الإعلان.",
    scope: "تتغير في آن واحد للإعلان وكل مساكنه وأسعاره. ستستخدم روابط الدفع ووكيل الذكاء الاصطناعي والمغادرة المتأخرة هذه العملة.",
    label: "العملة",
    mismatch: "حالياً غير متطابقة: الإعلان يقول {listing} ومساكنه تحصّل بـ {units}. عند الحفظ سيصبح كل شيء بالعملة نفسها.",
    channexTitle: "لا يمكن تغييرها من هنا",
    cancel: "إلغاء",
    close: "حسناً",
    save: "حفظ",
    saving: "جارٍ الحفظ…",
    saved: "تم تحديث عملة الإعلان إلى {currency}.",
    error: "تعذّر تغيير العملة. حاول مرة أخرى.",
  },
  sugerencia: {
    titleCountry: "هذا الإعلان يحصّل بـ {current}",
    textCountry: "في {country} يُدفع عادةً بـ {suggested}. إذا غيّرتها فستستخدم روابط الدفع ووكيل الذكاء الاصطناعي والمغادرة المتأخرة {suggested}.",
    titleMismatch: "عملات هذا الإعلان غير متطابقة",
    textMismatch: "الإعلان يقول {listing} ومساكنه تحصّل بـ {units}. اترك عملة واحدة ليتطابق ما يعلنه الذكاء الاصطناعي مع ما يُحصّل.",
    useSuggested: "التغيير إلى {currency}",
    other: "اختيار أخرى",
    keep: "الإبقاء على {currency}",
  },
};
